import React from 'react';
import { LucideIcon } from 'lucide-react';
import clsx from 'clsx';

interface InfoBoxProps {
  title: string;
  icon: LucideIcon;
  isActive: boolean;
  onClick: () => void;
  activeColor: string;
}

const InfoBox: React.FC<InfoBoxProps> = ({ title, icon: Icon, isActive, onClick, activeColor }) => {
  return (
    <div
      className={clsx(
        'cursor-pointer rounded-lg border p-10 transition-colors',
        isActive ? `border-${activeColor}-400 bg-gray-700` : 'border-gray-700 bg-gray-800 hover:border-gray-500',
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <Icon className={`h-10 w-10 text-${activeColor}-400`} />
        <h3 className="text-lg font-medium text-white">{title}</h3>
      </div>
    </div>
  );
};

export default InfoBox;
